module.exports = __webpack_public_path__ + "img/MASSIV_DT.d169f7b3.png";